module.exports = __webpack_public_path__ + "static/img/ce7e5add440ac2aa0555252ac246892.a2d1bfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ce7e5add440ac2aa0555252ac246892.png
// module id = oAlF
// module chunks = 29